<template>

    <div class="field">
        <label class="label" v-if="props.etichetta">{{ props.etichetta }}</label>
        <div class="field has-addons">
            <div class="control">
                <button class="button is-primary" @click="modificaValore(true)" :title="valoreTesto.length>1?'Listino unico':'Sdoppia listino'"><p><i class="fas fa-toggle-on" v-if="valoreTesto.length==2"></i><i class="fas fa-toggle-off" v-if="valoreTesto.length==1"></i></p></button>
            </div>
            <div class="control">
                <input class="input has-text-centered" type="text" v-model="valoreTesto[0]"
                    @change="modificaValore()">
            </div>
            <div class="control" v-if = "valoreTesto.length > 1">
                <input class="input has-text-centered" type="text" v-model="valoreTesto[1]"
                    @change="modificaValore()">
            </div>
        </div>
    </div>
</template>

<script setup>
    // import { set } from "core-js/core/dict";
import { defineProps, defineEmits, ref } from "vue";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        valore: {
            type: Array
        },
        identificativo: {
            type: String,
            default: ''
        },
        etichetta: {
            type: String,
            default: null
        }
        // solaLettura: {
        //    type: Boolean,
        //    default: false
        // }
    });
    const emit = defineEmits(['valoreCambiato']);

    // VARIABILI DEL COMPONENTE
    const valoreTesto = ref([]);
    let valoreNumerico = [];
    // const testoBottone = ref('SEL');

    // SETUP DEL COMPONENTE
    for (let i = 0; i < props.valore.length; i++) {
        if (props.valore[i]){
            valoreNumerico.push(props.valore[i]);
        } else {
            valoreNumerico.push(0);
        }
    }
    setupForm();

    // FUNZIONI DEL COMPONENTE
    function setupForm() {
        valoreTesto.value = [];
        for (let i = 0; i < valoreNumerico.length; i++) {
            valoreTesto.value.push(valoreNumerico[i].toLocaleString("it-IT", {
                notation: "standard",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2}));
        }
    }

    function modificaValore(toggle) {
        // Prepara il valore per la successiva restituzione tramite emit
        if (toggle) {
            valoreTesto.value.length == 1 ? valoreTesto.value.push('') : valoreTesto.value.pop();
        }
        let tempValoreNumerico = [];
        for (let i = 0; i < valoreTesto.value.length; i++) {
            if (valoreTesto.value[i] != '') {
                tempValoreNumerico.push(parseFloat( valoreTesto.value[i].replace('.', '').replace('.', '').replace(/,/, '.') ) );
            } else {
                tempValoreNumerico.push(0);
            }
        }
        emit('valoreCambiato', tempValoreNumerico, props.identificativo);
        // setupForm();
    }

</script>